import React from "react";

import { Route, Switch } from "react-router-dom";

import AuthorScreen from "screens/AuthorScreen";
import CarsScreen from "screens/CarsScreen";
import DocsScreen from "screens/DocsScreen";
import ExamplesScreen from "screens/ExamplesScreen";

import BasicScreen from "../BasicScreen";
import HomeScreen from "../HomeScreen";
import ProductScreen from "../ProductScreen";
import ProductsScreen from "../ProductsScreen";
import UsersScreen from "../UsersScreen";

function MainRoutes() {
  return (
    <Switch>
      <Route path="/examples/products/:id">
        <ProductScreen />
      </Route>
      <Route path="/examples/products">
        <ProductsScreen />
      </Route>
      <Route path="/examples/users">
        <UsersScreen />
      </Route>
      <Route path="/examples/basic">
        <BasicScreen />
      </Route>
      <Route path="/examples/cars">
        <CarsScreen />
      </Route>
      <Route path="/examples">
        <ExamplesScreen />
      </Route>
      <Route path="/docs">
        <DocsScreen />
      </Route>
      <Route path="/author">
        <AuthorScreen />
      </Route>
      <Route path="/">
        <HomeScreen />
      </Route>
    </Switch>
  );
}

export default React.memo(MainRoutes);
